export default __webpack_public_path__ + "static/media/ostaleBoje.aaede565.jpeg";